import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
}

/** Restrict route to instance administrators (user management, operations). */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuth();
  if (user?.role?.toLowerCase() !== 'admin') {
    return <Navigate to="/profile" replace />;
  }
  return <>{children}</>;
};
